import axios from 'axios';
// 创建 axios 实例
const requests = axios.create({
	baseURL: process.env.VUE_APP_SERVE,
	timeout: 6000 // 请求超时时间
});
// let order = 0;
const err = error => {
	return Promise.reject(error);
};

// request interceptor(请求拦截器)
requests.interceptors.request.use(config => {
	// console.log('请求拦截器', config);
	return config;
}, err);

// response interceptor（接收拦截器）
requests.interceptors.response.use(response => {
	// console.log('接收拦截器', response);
	return response.data;
}, err);

export default requests;